import type { BrandModules } from "@/shared/brand";

/**
 * OEM 贴牌(设计稿 §2.4):外部工具页的每张外链卡各挂在哪个品牌模块开关下。
 * 外呼获客与数据获客是**同一个外呼系统链接**(见 ExternalToolsPage 的 XIAOBANG_LINK),同一个开关;
 * 邮件获客走老 GEO 系统(/proxy/oldgeo);GEO管理系统(第三方 geo.xbgeo.cn)有**自己的开关**。直营全开,渠道默认全关。
 *
 * ★ geoAdmin 曾经暂挂在 legacyGeo 下,2026-10-10 拆出来:legacyGeo 是「邮件获客」,开了它不等于要放开
 * 第三方 GEO 后台的管理入口。拆开后,只买邮件模块的渠道不会看到这张卡。
 */
export const EXTERNAL_TOOL_MODULE: Record<string, keyof BrandModules> = {
  waihu: "outboundCall",
  geo: "outboundCall",
  email: "legacyGeo",
  geoAdmin: "geoAdmin",
};

/** 外部工具页会读到的模块位。写成联合而不是 `keyof BrandModules`:别的模块位(漫剧/算力)不归这一页管。 */
type ExternalModuleKey = "outboundCall" | "legacyGeo" | "geoAdmin";

/** 某个工具 key 在当前品牌下能不能用。未登记的 key 视为不可用(不给渠道域名意外露外链)。 */
export function isExternalToolEnabled(
  toolKey: string,
  modules: Pick<BrandModules, ExternalModuleKey>
): boolean {
  const mod = EXTERNAL_TOOL_MODULE[toolKey] as ExternalModuleKey | undefined;
  return !!mod && !!modules[mod];
}

/** 全部卡关 → 获客舱的「外部工具」二级入口整个隐藏。 */
export function anyExternalToolEnabled(modules: Pick<BrandModules, ExternalModuleKey>): boolean {
  return Object.keys(EXTERNAL_TOOL_MODULE).some((k) => isExternalToolEnabled(k, modules));
}
